import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fontSizes, styled } from "@iventis/styles";
import { Theme } from "@emotion/react";
import React from "react";

export const LibraryTileNodePreview: React.FC<{ childCount: number }> = ({ childCount }) => (
    <StyledPreviewContiner>
        <FontAwesomeIcon size="6x" icon={["fas", "folder-closed"]} />
        {typeof childCount === "number" && <StyledChildCount>{childCount}</StyledChildCount>}
    </StyledPreviewContiner>
);

const StyledPreviewContiner = styled.div`
    position: relative;
`;

const StyledChildCount = styled.div`
    position: absolute;
    bottom: 15px;
    right: 10px;
    color: ${({ theme }: { theme: Theme }) => theme.typographyColors.blank};
    font-weight: 400;
    font-size: ${fontSizes.xLarge};
`;
